import React, { createContext, useContext } from "react";
import { ControlTowerContext } from "#utils/context";

const ControlTowerConfigContext = createContext<ControlTowerContext | undefined>(undefined);

export interface ControlTowerProviderProps {
  children: React.ReactNode;
  context: ControlTowerContext;
}

export const ControlTowerProvider: React.FC<ControlTowerProviderProps> = ({
  children,
  context,
}) => {
  return (
    <ControlTowerConfigContext.Provider value={context}>
      {children}
    </ControlTowerConfigContext.Provider>
  );
};

export const useControlTowerContext = (): ControlTowerContext => {
  const context = useContext(ControlTowerConfigContext);
  if (context === undefined) {
    throw new Error("useControlTowerContext must be used within a ControlTowerProvider");
  }
  return context;
};
